import useMailSender from "hooks/useMailSender.js";
import { useUser } from "contexts/userContext/userContext.js";
import { useMail } from "contexts/mailContext/mailContext.js";

const useConditionToShowReupload = () => {
  const { getMailSecurity, getMailMetaData, getSender, getIsCollection } =
    useMail();

  const { isMailSender } = useMailSender();
  const { getUserData, isLoggedIn } = useUser();

  const conditionToShowReupload = () => {
    if (getIsCollection()) {
      return false;
    }
    if (isMailSender()) {
      return true;
    }
    const collaborationOptions = getMailSecurity()?.collaboration;
    if (collaborationOptions === "recipients") {
      return getMailMetaData().RecipientsList?.includes(getUserData().UserName);
    }
    if (collaborationOptions === "link") {
      return true;
    }
    if (collaborationOptions === "organization") {
      const topUserEmail = getUserData().TopUserEmail;
      const userEmail = getUserData().UserName;
      const senderEmail = getSender().email;
      const topSenderEmail = getSender().topUserEmail;
      return (
        userEmail === senderEmail || // user is sender
        userEmail === topSenderEmail || // user is topUser of sender
        topUserEmail === senderEmail || // user`s topUser is sender
        topUserEmail === topSenderEmail // user`s topUser is topUser of sender
      );
    }
  };

  return conditionToShowReupload();
};

export default useConditionToShowReupload;
